import {Button, Col, Row} from "antd";
import CalendarModalParent from "./calendarModalParent";
import {useEffect, useState} from "react";
import SelectDepartmentReport from "../items/DepartmentReport";
import SelectTypeReport from "../items/TypeReport";
import {mapTitleDate} from "../common/mapTitleDate";
import {KeyConstant} from "../constant/keyConstant";
import {useNavigate, useSearchParams} from "react-router-dom";
import {typeReport} from "../common/typeReport";
import {DefaultValue} from "../constant/DefaultValue";
import {KeyFilter, KeyFilter as Field} from "../constant/keyFilter";
import {useDispatch, useSelector} from "react-redux";
import {onReloadData} from "../../../../redux/actions/layout/interaction/action";
import {t} from "i18next";

const FilterModal = ({onCancel, onDestroy, destroy}) => {
    const [searchParams] = useSearchParams()
    const [visible, setVisible] = useState(false)
    const [objectParam, setObjectParam] = useState({
        typeReport: searchParams.get(KeyFilter.type_report) || typeReport[0]?.value,
        startDate: searchParams.get(Field.START_DATE) || DefaultValue.startDate,
        endDate: searchParams.get(Field.END_DATE) || DefaultValue.endDate ,
        departmentReport : searchParams.getAll(KeyFilter.department_id) ?
            searchParams.getAll(KeyFilter.department_id)?.map(value => Number(value)) :  []
    })
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)
    const convert = () => {

        setObjectParam({
            departmentReport: [],
            typeReport: typeReport[0]?.value,
            startDate: DefaultValue.startDate,
            endDate: DefaultValue.endDate
        })
    }


    useEffect(() => {
        if (destroy) {
            convert()
            onDestroy(false)
        }
    }, [destroy])

    const submit = () => {
        searchParams.delete(Field.START_DATE)
        if (objectParam?.startDate) {
            searchParams.append(Field.START_DATE, objectParam.startDate)
        }
        searchParams.delete(Field.END_DATE)
        if (objectParam?.endDate) {
            searchParams.append(Field.END_DATE, objectParam.endDate)
        }

        searchParams.delete(KeyFilter.department_id)
        if (objectParam?.departmentReport) {

            objectParam.departmentReport?.map(item => {
                searchParams.append(KeyFilter.department_id, item)
                return []
            })

        }
        searchParams.delete(KeyFilter.type_report)
        searchParams.append(KeyFilter.type_report, objectParam.typeReport)

        navigate(`?${searchParams.toString()}`)
        dispatch(onReloadData(!reloadData))
        onCancel()
    }

    const onSubmit = (startDateValue, endDateValue, type) => {

        setObjectParam({
            ...objectParam,
            startDate: startDateValue,
            endDate: endDateValue,
            type: type,
        })
    }

    return (
        <div className={"p-6"}>

            <Row gutter={12} className={"mb-6"}>
                <Col span={6}>
                    { t("tnp.components.autoCheckInOut.titleRow.department")}
                </Col>
                <Col span={18}>
                    <SelectDepartmentReport
                        onChange={(value) =>
                            setObjectParam({
                                ...objectParam,
                                departmentReport: value
                            })
                        }
                        value={objectParam?.departmentReport || []}
                    />
                </Col>
            </Row>


            <Row gutter={12} className={"mb-6"}>
                <Col span={6}>
                    {t("tnp.components.common.text29")}
                </Col>
                <Col span={18}>
                    <SelectTypeReport onChange={(value) =>
                        setObjectParam({
                            ...objectParam,
                            typeReport: value,
                        })}
                                      value={objectParam?.typeReport || typeReport[0]?.value}
                    />
                </Col>
            </Row>

            <Row gutter={12} className={"mb-6"}>
                <Col span={6}>
                    {t("tnp.components.report.dateRange")}
                </Col>
                <Col span={18}>
                    <div className={" cursor-pointer whitespace-nowrap text-ellipsis overflow-hidden"}
                         onClick={() => setVisible(true)}>

                        <div className={" cursor-pointer truncate hover:text-sky-700"}
                             onClick={() => setVisible(true)}
                             style={{maxWidth: "100%"}}>
                            {mapTitleDate(objectParam?.type ? objectParam.type : KeyConstant.THIRTY_DAYS_AGO,
                                objectParam?.startDate ? objectParam.startDate :
                                    DefaultValue.startDate,
                                objectParam?.endDate ? objectParam.endDate :
                                    DefaultValue.startDate)}

                        </div>

                    </div>
                </Col>
            </Row>

            <Row gutter={12}>
                <Col span={15}/>
                <Col span={9} className={"flex"}>
                    <div className={"flex items-center"}>
                        <Button className={"mr-3"} onClick={() => onDestroy(true)}>
                            { t("tnp.components.report.reset")}
                        </Button>
                        <Button type="primary" onClick={submit}>
                            {t("tnp.components.timekeeping.text7")}
                        </Button>
                    </div>
                </Col>
            </Row>
            <CalendarModalParent visible={visible}
                                 onCancel={() => setVisible(false)}
                                 onSubmit={onSubmit}
                                 objectParam={objectParam}

            />

        </div>
    )
}

export default FilterModal
